import React from 'react';
import {
  LeadsFormSubmittedContainer,
  LeadsFormHeader,
  LeadsFormImages,
  LeadsFormContent,
  CloseIconWrapper,
  ContentTitle,
  ContentSubTitle,
  FormSubmittedImage,
} from './LeadsFormCapture.style';
import ContentLeadCapture from '../../locales/th/leadcapture.json';
import submitCheck from '../../common/assets/submitCheck.png';
import { CloseIcon } from '../global/icons/closeIcon/CloseIcon';
interface LeadsSuccessCapture {
  updateSuccessPopup: (value: boolean) => void;
}
export const LeadsSuccessPopup: React.FC<LeadsSuccessCapture> = ({
  updateSuccessPopup,
}) => {
  return (
    <LeadsFormSubmittedContainer data-testid="leads-success-capture">
      <LeadsFormHeader>
        <LeadsFormContent>
          <div>
            <LeadsFormImages>
              <FormSubmittedImage src={submitCheck} alt={'check-image'} />
            </LeadsFormImages>
          </div>
          <div>
            <ContentTitle>{ContentLeadCapture.sucessForm.title}</ContentTitle>
            <ContentSubTitle>
              {ContentLeadCapture.sucessForm.subTitle}
            </ContentSubTitle>
          </div>
        </LeadsFormContent>
      </LeadsFormHeader>
      <CloseIconWrapper onClick={() => updateSuccessPopup(false)}>
        <CloseIcon />
      </CloseIconWrapper>
    </LeadsFormSubmittedContainer>
  );
};
